// extracted by mini-css-extract-plugin
export default {"ResetPassword":"resetPassword_ResetPassword__uRAlB","checking":"resetPassword_checking__6f2rr"};